import { useState } from 'react';
import { SketchPicker } from 'react-color';
import styled from 'styled-components';
import { Button, lightTheme } from '@vgrubs/components';
import { Div, P, Modal } from '@vgrubs/components';

const Color = styled.div<{ focused: boolean; $disabled?: boolean }>`
  width: 100%;
  height: 40px;
  background-color: ${({ color }) => color};
  border-radius: 50px;
  border: 1px solid
    ${({ theme, focused }) => (focused ? theme.primary : theme.darkGray + '80')};

  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

// react-color@3.0.0-beta.3's SketchPicker ignores the `styles` prop (it never
// merges it into reactCSS), so strip the default card chrome via CSS on the
// rendered `.sketch-picker` root instead.
const PickerWrapper = styled.div`
  .sketch-picker {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }
`;

export const AdminColorInput = ({
  onChange,
  color,
  label,
  $textCenter,
  disabled,
}: {
  onChange: (color: string) => void;
  color: string;
  label: string;
  $textCenter?: boolean;
  /** Display-only swatch - the picker never opens. */
  disabled?: boolean;
}) => {
  const [colorModal, setColorModal] = useState(false);

  return (
    <Div>
      <P $mb="8" $center={$textCenter}>
        <b>{label}</b>
      </P>
      <Color
        onClick={() => !disabled && setColorModal(!colorModal)}
        color={color}
        focused={colorModal}
        $disabled={disabled}
      />

      <Modal
        isOpen={colorModal}
        closeModal={() => setColorModal(false)}
        logo={false}
        width="300px"
        exitButton={false}
        backgroundColor={lightTheme.white}
      >
        <PickerWrapper>
          <SketchPicker
            width={'100%'}
            color={color}
            onChangeComplete={(e) => onChange(e.hex)}
          />
        </PickerWrapper>
        <Button
          $mt="12"
          $small
          $w="100%"
          $selected
          onClick={() => setColorModal(!colorModal)}
        >
          Done
        </Button>
      </Modal>
    </Div>
  );
};
